import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../../../utils";
import { Text } from "../../../Text";
import "../styles.scss";
import { TextTypes } from "../../../constants";

export const InsuranceField = ({ children, className, title }) => (
  <div className={createClassNameString(["apti-CompletedProfileInsurance--field", className])}>
    <Text type={TextTypes.label}>{title}</Text>
    {children}
  </div>
);

InsuranceField.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
};

InsuranceField.defaultProps = {
  children: <></>,
  className: undefined,
  title: "",
};
